import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Switch } from '../../components/ui/switch';
import { Badge } from '../../components/ui/badge';
import { BellOff, Trash2 } from 'lucide-react';
import { CONDITIONS } from './alertsConstants';

const AlertRow = ({ alert, onToggle, onDelete }) => {
  const cond = CONDITIONS.find((c) => c.id === alert.condition);
  const formatted = cond?.unit === '%' ? `${alert.threshold}%` : `$${alert.threshold}`;
  return (
    <div
      className="flex items-center justify-between p-3 border border-gray-100 rounded-lg hover:bg-gray-50"
      data-testid={`alert-row-${alert.symbol}`}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-purple-100 text-purple-700 font-bold flex items-center justify-center">
          {alert.symbol.charAt(0)}
        </div>
        <div>
          <div className="flex items-center gap-2">
            <span className="font-semibold">{alert.symbol}</span>
            {!alert.enabled && (
              <Badge variant="outline" className="text-xs">
                <BellOff size={10} className="mr-1" />
                Paused
              </Badge>
            )}
            {alert.trigger_count > 0 && (
              <Badge variant="outline" className="text-xs">
                triggered {alert.trigger_count}×
              </Badge>
            )}
            {alert.repeat === false && (
              <Badge variant="outline" className="text-xs text-amber-700 border-amber-200">
                one-shot
              </Badge>
            )}
          </div>
          <p className="text-xs text-gray-500">
            {cond?.label || alert.condition} <b>{formatted}</b>
            {alert.note ? <span className="text-gray-400"> · {alert.note}</span> : null}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <Switch
          checked={alert.enabled}
          onCheckedChange={() => onToggle(alert)}
          data-testid={`alert-toggle-${alert.symbol}`}
        />
        <Button
          size="icon"
          variant="ghost"
          className="text-red-600"
          onClick={() => onDelete(alert.id)}
          data-testid={`alert-delete-${alert.symbol}`}
        >
          <Trash2 size={16} />
        </Button>
      </div>
    </div>
  );
};

const AlertsListCard = ({ alerts, loading, onToggle, onDelete }) => (
  <Card data-testid="alerts-list-card">
    <CardHeader>
      <CardTitle className="text-lg">My Alerts · {alerts.length}</CardTitle>
    </CardHeader>
    <CardContent>
      {loading ? (
        <p className="text-gray-500 text-sm py-6 text-center">Loading…</p>
      ) : alerts.length === 0 ? (
        <p className="text-gray-500 text-sm py-6 text-center" data-testid="alerts-empty">
          No alerts yet. Create one above.
        </p>
      ) : (
        <div className="space-y-2">
          {alerts.map((a) => (
            <AlertRow key={a.id} alert={a} onToggle={onToggle} onDelete={onDelete} />
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);

export default AlertsListCard;
